'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BBBOZKTU.mjs";

// src/play/Play.tsx
import { jsx } from "react/jsx-runtime";
var PlayIcon = (props) => {
  return /* @__PURE__ */ jsx(
    "svg",
    __spreadProps(__spreadValues({
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.75 13.4253C6.75 13.7472 7.12891 13.9195 7.3715 13.7079L12.427 9.29822C12.598 9.14908 12.5984 8.88346 12.4279 8.73379L7.37238 4.2963C7.13003 4.08358 6.75 4.25567 6.75 4.57813V13.4253Z",
          fill: "currentColor"
        }
      )
    })
  );
};

export {
  PlayIcon
};
//# sourceMappingURL=chunk-WO2SEZNK.mjs.map